import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../infrastructure/firebase/firebaseConfig';

/**
 * Subscribes to /maintenance/active. Returns true while the daily cleanup
 * function is wiping rooms. The flag is server-controlled — clients only read.
 */
export function useMaintenance(): boolean {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const r = ref(database, 'maintenance/active');
    const unsub = onValue(
      r,
      snap => setActive(snap.val() === true),
      () => setActive(false)
    );
    return () => unsub();
  }, []);

  return active;
}
